import { COURSE_TYPE } from "@types";

export const handleCourseUrl = (
  type: COURSE_TYPE | "landing" | undefined,
  sku: string | undefined,
) => {
  switch (type) {
    case COURSE_TYPE.COURSE:
      return `/courses/${sku}`;
    case COURSE_TYPE.PODCAST:
      return `/podcasts/${sku}`;
    case COURSE_TYPE.AUDIOBOOK:
      return `/audiobooks/${sku}`;
    case COURSE_TYPE.WEBINAR:
      return `/webinars/${sku}`;
    case COURSE_TYPE.EXAM:
      return `/exams/${sku}`;
    case COURSE_TYPE.BLIND:
      return `/blinds/${sku}`;
    case COURSE_TYPE.PACK:
      return `/exams/${sku}`;
    case COURSE_TYPE.TEXT:
      return `/texts/${sku}`;
    case COURSE_TYPE.PACKAGE:
      return `/packages/${sku}`;
    case COURSE_TYPE.VIDEO:
      return `/videos/${sku}`;
    case "landing":
      return `/how-to-learn/${sku}`;
    default:
      return `/courses/${sku}`;
  }
};
